<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import ModuleTitle from '@/components/layout/ModuleTitle'

  export default {
    name: 'DownloadsModule',
    components: {
      ModuleTitle,
    },
    props: {
      // only get prop options key
      options: {
        type: Object,
        default: _ => {},
      },
    },
  }
</script>
